import * as Sentry from '@sentry/browser'
import { Config } from './EnvConfig'

const isNotDevEnvironment = process.env['NODE_ENV'] === 'production' //TODO: need to check

const ignoreErrors = [
   'getReadModeExtract',
   'getReadModeConfig',
   'getReadModeRender',
   'ServiceWorker script evaluation failed',
   'ResizeObserver loop limit exceeded',
   'Failed to register a ServiceWorker'
]

function shouldIgnoreError(errorMessage: Error | string) {
   let ignoreError = false
   ignoreErrors.forEach(errorText => {
      if (errorMessage.toString().includes(errorText)) {
         ignoreError = true
      }
   })
   return ignoreError
}

function getErrorMessage(e: Error): string | undefined {
   return e && e.stack && e.message
}

// Initialize Sentry
export const initSentry = () => {
   if (!Config.SENTRY_DSN_KEY) {
      console.warn('Sentry DSN not found. Error tracking will be disabled.')
      return
   }

   Sentry.init({
      dsn: Config.SENTRY_DSN_KEY,
      sendDefaultPii: true,
      environment: Config.ENV_NAME
   })
}

// Set user context
export const setSentryUser = (user: {
   id: string
   email?: string
   username?: string
}) => {
   Sentry.setUser(user)
}

// Clear user context
export const clearSentryUser = () => {
   Sentry.setUser(null)
}

// Add custom breadcrumb
export const addSentryBreadcrumb = (
   category: string,
   message: string,
   data?: Record<string, any>
) => {
   Sentry.addBreadcrumb({
      category,
      message,
      data,
      level: 'info'
   })
}

// Capture exception
export const captureException = (
   error: Error,
   context?: Record<string, any>
) => {
   if (context && 'userId' in context) {
      Sentry.setUser({
         id: context['userId'],
         username: context['userName']
      })
   }
   Sentry.captureException(error, {
      extra: context
   })
}

// Capture message
export const captureMessage = (
   message: string,
   level: Sentry.SeverityLevel = 'info'
) => {
   Sentry.captureMessage(message, {
      level
   })
}

// Set custom tags
export const setSentryTags = (tags: Record<string, string>) => {
   Object.entries(tags).forEach(([key, value]) => {
      Sentry.setTag(key, value)
   })
}

// Set custom context
export const setSentryContext = (
   name: string,
   context: Record<string, any>
) => {
   Sentry.setContext(name, context)
}

export function captureSentryException(
   error: Error,
   errorInfo: any = undefined
): void {
   if (error && isNotDevEnvironment) {
      let updatedError = error
      if (!getErrorMessage(error)) {
         updatedError = new Error(error.toString())
      }
      if (errorInfo) {
         Sentry.configureScope((scope: Sentry.Scope) => {
            Object.keys(errorInfo).forEach(key => {
               scope.setExtra(key, errorInfo[key])
            })
         })
      }
      const ignoreError = shouldIgnoreError(error)
      if (!ignoreError) {
         Sentry.captureException(updatedError)
      }
   }
}
